'use strict';

//
// Tempus Dominus Datepicker Global Settings(learn more: https://getdatepicker.com/6/options/)
//

tempusDominus.DefaultOptions.display.icons = {
  time: 'ki-outline ki-time fs-3',
  date: 'ki-outline ki-calendar fs-3',
  up: 'ki-outline ki-up fs-3',
  down: 'ki-outline ki-down fs-3',
  previous: 'ki-outline ki-left fs-3',
  next: 'ki-outline ki-right fs-3',
  today: 'ki-outline ki-calendar-tick fs-3',
  clear: 'ki-outline ki-trash fs-3',
  close: 'ki-outline ki-cross fs-2',
};
